export const ONE_C = '1c';
export const CSV = 'csv';
export const DOC = 'doc';
export const PDF = 'pdf';
export const PNG = 'png';
export const PPT = 'ppt';
export const SKETCH = 'sketch';
export const SVG = 'svg';
export const TXT = 'txt';
export const XLS = 'xls';
export const XML = 'xml';

/* ALFABANKRU-20325 */
export const FILE_TYPES = [ONE_C, CSV, DOC, PDF, PNG, PPT, SKETCH, SVG, TXT, XLS, XML];

export const WHITE = 'white';
export const BLUE = 'blue';

export const DEFAULT_THEME = WHITE;

export const THEMES = [WHITE, BLUE];
